module.exports = __webpack_public_path__ + "ca3e6b495083c12b09884173f60accc8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-captain.png
// module id = 2867
// module chunks = 0